import axios from "axios";
import { URLs, OutreachStatuses, LOADER_TYPES } from "app/shared/constants";

export const getOutreachErrorSummary = async (
  outreach,
  setErrorList,
  setAlert,
  newErrorRecord,
  t,
  setLoader
) => {
  try {
    const { id, waveName, status } = outreach;
    setLoader(LOADER_TYPES.OUTREACH_FAILURE_SUMMARY, true);

    const response = await axios.get(
      `${URLs.GET_OUTREACH_URL_BASE}/${id}${URLs.GET_STUDY_LISTING_ERROR_SUMMARY}`
    );

    const { failureReason, report } = response.data;

    const records = [
      ...(failureReason
        ? [
            newErrorRecord(
              t("OutreachFailureSummary.outreach"),
              waveName,
              failureReason
            ),
          ]
        : []),
      ...(report && status === OutreachStatuses.FINISHED_WITH_ERROR
        ? report.map(({ mrn, failureReason }) =>
            newErrorRecord(t("OutreachFailureSummary.mrn"), mrn, failureReason)
          )
        : []),
    ];

    setErrorList(records);
    setLoader(LOADER_TYPES.OUTREACH_FAILURE_SUMMARY, false);
  } catch (error) {
    setAlert("error", error.message);
  }
};
